import { createFileRoute } from '@tanstack/react-router'
import { SensorInstalledSuccessfully } from '@/components/installFlowV2/sensor-installed-successfully'
import { z } from 'zod'

export const Route = createFileRoute('/installFlow/sensor-installed')({
  component: SensorInstalledSuccessfully,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
    installSensorKitSerialNumber: z.string().optional(),
  }),
})


